import { Instagram, Linkedin, Mail, Twitter } from 'lucide-react'
import { Link } from 'react-router-dom'
import { PATHS } from '@/app/router/routes'

function TikTokIcon({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
  )
}

const socialLinks = [
  { icon: Twitter, href: 'https://twitter.com/returnedcom', label: 'X (Twitter)' },
  { icon: Linkedin, href: 'https://www.linkedin.com/company/returnedcom/', label: 'LinkedIn' },
  { icon: Instagram, href: 'https://www.instagram.com/returnedcom/', label: 'Instagram' },
  { icon: TikTokIcon, href: 'https://www.tiktok.com/@returnedcom', label: 'TikTok' },
]

const productLinks = [
  { label: 'Reeva', href: 'https://helloreeva.com' },
  { label: 'SayWordy', href: 'https://saywordy.com' },
  { label: 'Loveline', href: 'https://getloveline.com' },
  { label: 'Hold For Me', href: 'https://holdforme.com' },
]

const companyLinks = [
  { label: 'About', to: PATHS.about },
  { label: 'Blog', to: PATHS.blog },
  { label: 'Careers', to: PATHS.careers },
  { label: 'Human+AI Project', to: PATHS.humanAiProject },
]

const legalLinks = [
  { label: 'Privacy', to: PATHS.privacy },
  { label: 'Terms', to: PATHS.terms },
]

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="landing-section footer-root">
      <div className="landing-container">
        <div className="footer-grid footer-main">
          <div>
            <Link to={PATHS.home} className="footer-brand-link">
              <img src="/logo-gradient.svg" alt="Returned" className="footer-logo" />
              <span className="footer-brand">Returned</span>
              <span className="footer-brand-dotcom">.com</span>
            </Link>
            <p className="footer-description">
              AI products that deepen human connection.
            </p>

            <div className="footer-socials">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="footer-social-link"
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="footer-heading">Products</h4>
            <ul className="footer-list">
              {productLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} target="_blank" rel="noopener noreferrer" className="footer-link">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-list">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-list">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="footer-heading">Contact</h4>
            <a href="mailto:hello@returned.com" className="footer-link footer-contact-link">
              <Mail size={16} />
              hello@returned.com
            </a>
            <a href="sms:+17205007000" className="footer-link">Text: 720-500-7000</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-bottom-copy">&copy; {currentYear} Returned.com, Inc.</p>
          <p className="footer-bottom-copy">Built with ❤️ from Boulder → Tokyo → Tainan</p>
        </div>
      </div>
    </footer>
  )
}
